import { Consumer } from './consumer';

export class ConsumerSelectDialog {
  excludeConsumerIds: Array<string>;
}
